"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Sign Internal OpenAPI
 * Sign Internal OpenAPI spec
 *
 * The version of the OpenAPI document: 0.1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.UploadIntegrationsToJSON = exports.UploadIntegrationsFromJSONTyped = exports.UploadIntegrationsFromJSON = exports.instanceOfUploadIntegrations = exports.attributeTypeMapUploadIntegrations = void 0;
var BoxIntegration_1 = require("./BoxIntegration");
var EvernoteIntegration_1 = require("./EvernoteIntegration");
var OneDriveIntegration_1 = require("./OneDriveIntegration");
var GoogleDriveIntegration_1 = require("./GoogleDriveIntegration");
var DropboxIntegration_1 = require("./DropboxIntegration");
exports.attributeTypeMapUploadIntegrations = [
    {
        name: "D",
        type: "DropboxIntegration",
    },
    {
        name: "G",
        type: "GoogleDriveIntegration",
    },
    {
        name: "B",
        type: "BoxIntegration",
    },
    {
        name: "E",
        type: "EvernoteIntegration",
    },
    {
        name: "T",
        type: "OneDriveIntegration",
    },
];
/**
 * Check if a given object implements the UploadIntegrations interface.
 */
function instanceOfUploadIntegrations(value) {
    return true;
}
exports.instanceOfUploadIntegrations = instanceOfUploadIntegrations;
function UploadIntegrationsFromJSON(json) {
    return UploadIntegrationsFromJSONTyped(json, false);
}
exports.UploadIntegrationsFromJSON = UploadIntegrationsFromJSON;
function UploadIntegrationsFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        D: json["D"] == null ? undefined : (0, DropboxIntegration_1.DropboxIntegrationFromJSON)(json["D"]),
        G: json["G"] == null ? undefined : (0, GoogleDriveIntegration_1.GoogleDriveIntegrationFromJSON)(json["G"]),
        B: json["B"] == null ? undefined : (0, BoxIntegration_1.BoxIntegrationFromJSON)(json["B"]),
        E: json["E"] == null ? undefined : (0, EvernoteIntegration_1.EvernoteIntegrationFromJSON)(json["E"]),
        T: json["T"] == null ? undefined : (0, OneDriveIntegration_1.OneDriveIntegrationFromJSON)(json["T"]),
    };
}
exports.UploadIntegrationsFromJSONTyped = UploadIntegrationsFromJSONTyped;
function UploadIntegrationsToJSON(value) {
    if (value == null) {
        return value;
    }
    return {
        D: (0, DropboxIntegration_1.DropboxIntegrationToJSON)(value["D"]),
        G: (0, GoogleDriveIntegration_1.GoogleDriveIntegrationToJSON)(value["G"]),
        B: (0, BoxIntegration_1.BoxIntegrationToJSON)(value["B"]),
        E: (0, EvernoteIntegration_1.EvernoteIntegrationToJSON)(value["E"]),
        T: (0, OneDriveIntegration_1.OneDriveIntegrationToJSON)(value["T"]),
    };
}
exports.UploadIntegrationsToJSON = UploadIntegrationsToJSON;
